import { getHTagNumber, HeadingStructureFailedReason } from '@wix/a11y-rules';
export const getHeadingStructureElementCounts = (htmlStrings, failHeadings, failReasons) => {
  const isNoMainHeading = failReasons.includes(HeadingStructureFailedReason.NoMainHeading);
  const isMultipleMainHeading = failReasons.includes(HeadingStructureFailedReason.MultipleMainHeadings);
  return htmlStrings.reduce((acc, _ref, index) => {
    let {
      id,
      htmlString
    } = _ref;
    const headingDefinition = getHTagNumber(htmlString);
    const inFailedElement = failHeadings.some(failHeading => failHeading.id === id);
    const isFailed = inFailedElement || isNoMainHeading && index === 0 || isMultipleMainHeading && headingDefinition === 1;
    acc.total += 1;
    acc.fail += Number(isFailed);
    return acc;
  }, {
    fail: 0,
    total: 0
  });
};
//# sourceMappingURL=get-heading-structure-element-counts.js.map